/* eslint-disable max-len */
import React from 'react';
import NavRoutes from './NavRoutes';
import { BASE_ROUTE_ADMIN } from './BaseRoute';

// Admin Components here
import Home from '../../modules/admin/modules/Home/Home';
import { CustomRouteInterface } from './CustomRoute';
import Logout from '../../modules/public/Logout/Logout';
import ResetPasswordPostLogin from '../../modules/shared/UserResetPassword/UserResetPassword';

const PriorAuthorization = React.lazy(
  () =>
    import('../../modules/admin/modules/PriorAuthorization/PriorAuthorization')
);

const ClaimsTickets = React.lazy(
  () => import('../../modules/admin/modules/ClaimsTickets/ClaimsTickets')
);

const ReferralTickets = React.lazy(
  () => import('../../modules/admin/modules/ReferralsTickets/ReferralsTickets')
);

const ClinicGroups = React.lazy(
  () => import('../../modules/admin/modules/ClinicGroups/ClinicGroups')
);
const Profile = React.lazy(
  () => import('../../modules/shared/Profile/Profile')
);

const Patients = React.lazy(
  () => import('../../modules/admin/modules/Patients/Patients')
);
const Appointments = React.lazy(
  () => import('../../modules/admin/modules/Appointments/Appointments')
);
const Invoices = React.lazy(
  () => import('../../modules/admin/modules/Invoices/Invoices')
);
const AdminDashboard = React.lazy(
  () => import('../../modules/admin/modules/AdminDashboard/AdminDashboard')
);
const UserDashboard = React.lazy(
  () => import('../../modules/admin/modules/AdminDashboard/UserDashboard')
);
const Report = React.lazy(
  () => import('../../modules/admin/modules/Report/Report')
);
const AdminUsers = React.lazy(
  () => import('../../modules/admin/modules/AdminUsers/AdminUsers')
);
const Payments = React.lazy(
  () =>
    import('../../modules/admin/modules/Invoices/PaymentHistory/PaymentHistory')
);

const IncomingSms = React.lazy(
  () => import('../../modules/admin/modules/Sms/IncomingSmsRoot')
);

const Patientrecall = React.lazy(
  () => import('../../modules/admin/modules/PatientRecall/PatientRecall')
);
const CCM = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/ChronicCareManagement/ChronicCareManage'
    )
);
const CCMDashboard = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/ChronicCareManagement/module-components/CCMDashboard/CCMDashboard'
    )
);

const CCMPatients = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/ChronicCareManagement/module-components/CCMPatients/CCMPatients'
    )
);

const CCMReports = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/ChronicCareManagement/module-components/CCMReports/CCMReports'
    )
);

const CCMSpecificMonthReports = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/ChronicCareManagement/module-components/CCMReports/CCMSpecificMonthReports/CCMSpecificMonthReports'
    )
);

const Reports = React.lazy(
  () => import('../../modules/admin/modules/Reports/Reports')
);

const GatheredFeedBack = React.lazy(
  () => import('../../modules/admin/modules/GatherFeedBack/GatheredFeedBack')
);

const ScheduledJobs = React.lazy(
  () => import('../../modules/admin/modules/ScheduledJobs/ScheduledJobs')
);

const SystemLevelHolidaysList = React.lazy(
  () => import('../../modules/admin/modules/SystemLevelHolidays/HolidaysList')
);

const PatientForm = React.lazy(
  () => import('../../modules/admin/modules/PatientForm/PatientForm')
);

const Claims = React.lazy(
  () => import('../../modules/admin/modules/Claims/Claims')
);

const SystemLevelVaccinesList = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/Vaccines/SystemLevelVaccines/SystemLevelVaccines'
    )
);

const SystemLevelD0ConfigurationList = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/SystemLevelD0Configuration/SystemLevelD0Configuration'
    )
);

const SystemLevelAppointmentTypeList = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/SystemLevelAppointmentType/SystemLevelAppointmentType'
    )
);

const EMRMappingsFileComponent = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/EMRMappingsFile/EMRMappingsFileComponent'
    )
);

const EmrSync = React.lazy(
  () => import('../../modules/admin/modules/EmrSync/EmrSync')
);

const SystemLevelEmrSync = React.lazy(
  () =>
    import('../../modules/admin/modules/EmrSync/platform/SystemLevelEmrSync')
);

const UsersComponent = React.lazy(
  () =>
    import(
      '../../modules/admin/modules/Users/UsersComponent'
    )
);
const AdminHomeRoute = `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}`;

const AdminRoute: CustomRouteInterface = {
  baseName: BASE_ROUTE_ADMIN,
  params: BASE_ROUTE_ADMIN,
  exactFrom: `/${BASE_ROUTE_ADMIN}`,
  redirectTo: `${AdminHomeRoute}`,
  routes: [
    {
      path: `${AdminHomeRoute}`,
      component: Home,
      private: true,
      exactFrom: `${AdminHomeRoute}`,
      redirectTo: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.DASHBOARD}`,
      hasNoAccessPath: `/${NavRoutes.PUBLIC.LOGIN}`,
      routes: [
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.DASHBOARD}`,
          component: AdminDashboard
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.USERDASHBOARD}`,
          component: UserDashboard
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CLINICS}/:groupId/:clinicId/${NavRoutes.PRIVATE.ADMIN.REPORT}`,
          component: Report
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CLINICS}`,
          component: ClinicGroups
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.USER.CHANGE_PASSWORD}`,
          component: ResetPasswordPostLogin
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.PROFILE}`,
          component: Profile
        },

        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.PATIENTS}`,
          component: Patients
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.APPOINTMENTS}`,
          component: Appointments
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.INVOICES}`,
          component: Invoices
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.PAYMENTS}`,
          component: Payments
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.INCOMING_SMS}`,
          component: IncomingSms
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CLINICS}`,
          component: ClinicGroups
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.ADMIN}`,
          component: AdminUsers
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.PATIENT_RECALL}`,
          component: Patientrecall
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.REPORTS}`,
          component: Reports
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.PRIOR_AUTHORIZATIONS}`,
          component: PriorAuthorization
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CLAIMS_TICKETS}`,
          component: ClaimsTickets
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.REFERRAL_TICKETS}`,
          component: ReferralTickets
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.SCHEDULED_JOBS}`,
          component: ScheduledJobs
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.HOLIDAYS_LIST}`,
          component: SystemLevelHolidaysList
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}`,
          component: CCM,
          private: true,
          exactFrom: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}`,
          redirectTo: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.DASHBOARD}`,
          hasNoAccessPath: `/${NavRoutes.PUBLIC.LOGIN}`,
          routes: [
            {
              path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.PATIENTS}`,
              component: CCMPatients
            },
            {
              path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.DASHBOARD}`,
              component: CCMDashboard
            },
            {
              path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.BILLING}`,
              component: CCMReports,
              private: true,
              exactFrom: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.BILLING}`,
              redirectTo: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.BILLING}`,
              exact: true,
              hasNoAccessPath: `/${NavRoutes.PUBLIC.LOGIN}`,
              routes: [
                {
                  path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CCM}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.BILLING}/${NavRoutes.PRIVATE.ADMIN.CCM_TABS.REPORTS_TABS.BILLING}`,
                  component: CCMSpecificMonthReports
                }
              ]
            }
          ]
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.GATHERED_FEEDBACK}`,
          component: GatheredFeedBack
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.PATIENT_FORM}`,
          component: PatientForm
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.CLAIMS}`,
          component: Claims
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.VACCINES_LIST}`,
          component: SystemLevelVaccinesList
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.D0_CONFIGURATION}`,
          component: SystemLevelD0ConfigurationList
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.APPOINTMENT_TYPE}`,
          component: SystemLevelAppointmentTypeList
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.VOICE_AGENT_CONFIG}`,
          component: React.lazy(
            () =>
              import(
                '../../modules/admin/modules/SystemLevelVoiceAgentConfig/SystemLevelVoiceAgentConfig'
              )
          )
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.EMR_MAPPINGS_FILE}`,
          component: EMRMappingsFileComponent
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.EMR_SYNC}`,
          component: EmrSync
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.EMR_SYNC_PLATFORM}`,
          component: SystemLevelEmrSync
        },
        {
          path: `${AdminHomeRoute}/${NavRoutes.PRIVATE.ADMIN.USERS}`,
          component: UsersComponent
        }
      ]
    },
    {
      path: `/${NavRoutes.PUBLIC.LOGOUT}`,
      component: Logout
    }
  ]
};

export interface AdminRouteClinicParams {
  groupId: string | number | any;
  clinicId: string | number | any;
}

export default AdminRoute;
